'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _datepickerLocal = require('./datepicker.local.css');

var _datepickerLocal2 = _interopRequireDefault(_datepickerLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var DatepickerButton = function DatepickerButton(_ref) {
  var _classnames;

  var onClick = _ref.onClick,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      active = _ref.active,
      disabled = _ref.disabled,
      children = _ref.children;
  return _react2.default.createElement('button', {
    className: (0, _classnames3.default)(_datepickerLocal2.default.datepickerButton, _datepickerLocal2.default.button, (_classnames = {}, _defineProperty(_classnames, _datepickerLocal2.default.active, active), _defineProperty(_classnames, _datepickerLocal2.default.disabled, disabled), _classnames)),
    disabled: disabled,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  }, children);
};

DatepickerButton.propTypes = {
  active: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  children: _propTypes2.default.string.isRequired,
  onClick: _propTypes2.default.func.isRequired,
  onMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func
};
exports.default = DatepickerButton;